'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

var _listingModule = require('./listingModule');

var listingActions = _interopRequireWildcard(_listingModule);

var _termsModule = require('../terms/termsModule');

var termsActions = _interopRequireWildcard(_termsModule);

var _ListingDetails = require('./ListingDetails');

var _ListingDetails2 = _interopRequireDefault(_ListingDetails);

var _userProfileModule = require('../userProfile/userProfileModule');

var _Header = require('../shared/Header');

var _Header2 = _interopRequireDefault(_Header);

var _LoadingIndicator = require('../shared/LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Listing = function (_Component) {
  _inherits(Listing, _Component);

  function Listing() {
    _classCallCheck(this, Listing);

    return _possibleConstructorReturn(this, (Listing.__proto__ || Object.getPrototypeOf(Listing)).apply(this, arguments));
  }

  _createClass(Listing, [{
    key: 'componentWillMount',

    // Uncomment to turn on Server Side Rendering
    // static readyOnActions(dispatch, location, params) {
    //   return [
    //     () => dispatch(listingActions.fetchListingIfNeeded(params.id)),
    //   ];
    // }

    // componentDidMount() {
    //   const { dispatch, location, params } = this.props;

    //   Listing.readyOnActions(dispatch, location, params)
    //     .forEach(action => action());
    // }

    value: function componentWillMount() {
      if (!(0, _utils.isInvalidID)(this.props.params.id)) {
        this.props.isAppCenterEnabledCheck();
        this.props.fetchListingIfNeeded(this.props.params.id);
        if (!this.context.isPublic) {
          this.props.fetchTermsStatus(this.props.userPrefs.userId);
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var interval = window.setInterval(function () {
        if ((0, _has3.default)(_this2.props, 'listing[' + _this2.props.params.id + '].data.core.clientOptInType')) {
          if (_this2.props.listing[_this2.props.params.id].data.core.clientOptInType === 'ADMIN') {
            if (_this2.props.userPrefs.userId && (0, _has3.default)(_this2.context.userProfile, 'profile.Role') && _this2.context.userProfile.profile.Role === 1) {
              _this2.props.fetchLOAStatus(_this2.props.userPrefs.userId);
            }
            _this2.props.fetchLOAContent();
          }
          window.clearInterval(interval);
        }
      }, 1000);

      if (this.context.isPublic) {
        if ((0, _utils.canUseDOM)() && window.utag) {
          (0, _utils.sendPublicView)();
        }
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if ((0, _utils.isInvalidID)(this.props.params.id) || nextProps.listing[this.props.params.id].readyState === listingActions.LISTING_NOT_FOUND) {
        window.location = '/404';
      }
    }
  }, {
    key: 'getListing',
    value: function getListing() {
      return this.props.listing[this.props.params.id];
    }
  }, {
    key: 'getPageTitle',
    value: function getPageTitle() {
      var listing = this.getListing();

      if (!listing || listing.readyState !== listingActions.LISTING_FETCHED) {
        return 'Listing';
      }
      return listing.data.localized.name;
    }
  }, {
    key: 'renderListing',
    value: function renderListing() {
      var _props = this.props,
          userPrefs = _props.userPrefs,
          terms = _props.terms,
          offerings = _props.offerings;
      var _props$listing = this.props.listing,
          localizedRegions = _props$listing.localizedRegions,
          localizedCountries = _props$listing.localizedCountries;

      var listing = this.getListing().data;
      return _react2.default.createElement(_ListingDetails2.default, {
        terms: terms,
        listing: listing,
        userPrefs: userPrefs,
        offerings: offerings,
        localizedRegions: localizedRegions,
        localizedCountries: localizedCountries
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var readyState = this.getListing() ? this.getListing().readyState : listingActions.LISTING_FETCHING;

      var listingIsLoaded = readyState === listingActions.LISTING_FETCHED || readyState === listingActions.LISTING_NOT_FOUND;

      var listingTitle = readyState === listingActions.LISTING_FETCHED ? this.getListing().data.localized.title : '';

      // TODO: figure out why the details page won't update canonical, then re-enable
      // const links = [];
      // const listingID = listingIsLoaded ? this.getListing().data.ID : '';
      // if (isPublic(this.props.location.pathname) && listingIsLoaded) {
      //   links.push({
      //     href: `https://www.concur.com/app-center/listing/${listingID}`,
      //     rel: 'canonical',
      //   });
      // }

      var metaTags = [{
        name: 'description',
        content: listingIsLoaded ? listingTitle : 'App Center Listing'
      }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          meta: metaTags,
          title: this.context.getTitle(this.getPageTitle())
        }),
        _react2.default.createElement(_Header2.default, {
          listingId: this.props.params.id
        }),
        _react2.default.createElement(
          'div',
          { style: { minHeight: '550px' } },
          _react2.default.createElement(
            _LoadingIndicator2.default,
            { isLoaded: listingIsLoaded },
            readyState === listingActions.LISTING_FETCHED && this.renderListing()
          )
        )
      );
    }
  }]);

  return Listing;
}(_react.Component);

Listing.propTypes = {
  dispatch: _propTypes2.default.func,
  params: _propTypes2.default.any,
  listing: _propTypes2.default.object,
  isAppCenterEnabledCheck: _propTypes2.default.func.isRequired,
  fetchListingIfNeeded: _propTypes2.default.func.isRequired,
  fetchTermsStatus: _propTypes2.default.func.isRequired,
  fetchLOAStatus: _propTypes2.default.func.isRequired,
  fetchLOAContent: _propTypes2.default.func.isRequired,
  terms: _propTypes2.default.shape({
    appcenterStatus: _propTypes2.default.object,
    isTaCModalOpen: _propTypes2.default.bool,
    appcenterTerms: _propTypes2.default.string,
    ereceiptTerms: _propTypes2.default.string,
    ereceiptStatus: _propTypes2.default.object,
    sharedInfoStatus: _propTypes2.default.object
  }),
  userPrefs: _propTypes2.default.object
};

Listing.contextTypes = {
  isPublic: _propTypes2.default.bool,
  userProfile: _propTypes2.default.object,
  getTitle: _propTypes2.default.func
};

function mapStateToProps(state) {
  return {
    listing: state.listing,
    userPrefs: state.userPrefs,
    terms: state.terms,
    offerings: state.userProfile.offeringsEnabled
  };
}

var mapDispatchToProps = {
  fetchListingIfNeeded: listingActions.fetchListingIfNeeded,
  fetchTermsStatus: termsActions.fetchTermsStatus,
  fetchLOAStatus: termsActions.fetchLOAStatus,
  fetchLOAContent: termsActions.fetchLOAContent,
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Listing));


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ListingContainer.js
// module id = 575
// module chunks = 0